<template>
  <!-- 能效系统全部模块 -->
  <el-main class="full-module-panel">
    <!-- 大屏显示 -->
    <site-screen1 v-if="defaultMenuCode==='002'" :key="timeStamp"/>
    <site-screen2 v-if="defaultMenuCode==='001'" :key="timeStamp" @reloadPage="reloadPage" />
    <site-screen3 v-if="defaultMenuCode==='003'" :key="timeStamp"/>
    <!-- 能源监测 -->
    <configuration v-if="defaultMenuCode==='011'" :key="timeStamp"/>
    <energy-realtime v-if="defaultMenuCode==='012'" :key="timeStamp"/>
    <energy-parameter v-if="defaultMenuCode==='013'" :key="timeStamp"/>
    <transfer-monitor v-if="defaultMenuCode==='014'" :key="timeStamp"/>
    <!-- 节能分析 -->
    <energy-statistics v-if="defaultMenuCode==='021'" :key="timeStamp"/>
    <seg-statistics v-if="defaultMenuCode==='022'" :key="timeStamp"/>
    <loss-analyse v-if="defaultMenuCode==='023'" :key="timeStamp"/>
    <transfer-analyse v-if="defaultMenuCode==='024'" :key="timeStamp"/>
    <energy-contrast v-if="defaultMenuCode==='025'" :key="timeStamp"/>
    <protect-analyse v-if="defaultMenuCode==='026'" :key="timeStamp"/>
    <demand-analyse v-if="defaultMenuCode==='027'" :key="timeStamp"/>
    <!-- 电能质量 -->
    <harmonic-analyse v-if="defaultMenuCode==='031'" :key="timeStamp"/>
    <unbalance-analyse v-if="defaultMenuCode==='032'" :key="timeStamp"/>
    <pow-factor-analyse v-if="defaultMenuCode==='033'" :key="timeStamp"/>
    <!-- 用电安全 -->
    <energy-safety v-if="defaultMenuCode==='041'" :key="timeStamp"/>
    <!-- 其他设备 -->
    <protect-device v-if="defaultMenuCode === '111'" :key="timeStamp" />
    <!-- 告警管理 -->
    <warning-query v-if="defaultMenuCode==='051'" :key="timeStamp"/>
    <warning-profile v-if="defaultMenuCode==='052'" :key="timeStamp"/>
    <!-- 设备台账 -->
    <device-doc v-if="defaultMenuCode==='061'" :key="timeStamp"/>
    <!-- 报表管理 -->
    <energy-report v-if="defaultMenuCode==='071'" :key="timeStamp"/>
    <yuxing-energy-report v-if="defaultMenuCode==='072'" :key="timeStamp"/>
    <expense-report v-if="defaultMenuCode==='073'" :key="timeStamp"/>
    <demand-report v-if="defaultMenuCode==='074'" :key="timeStamp"/>
    <parameter-report v-if="defaultMenuCode==='075'" :key="timeStamp"/>
    <!-- 报告管理 -->
    <save-energy-report v-if="defaultMenuCode==='081'" :key="timeStamp"/>
    <energy-quality-report v-if="defaultMenuCode==='082'" :key="timeStamp"/>
    <energy-safety-report v-if="defaultMenuCode==='083'" :key="timeStamp"/>
    <!-- 系统设置 -->
    <energy-price v-if="defaultMenuCode==='091'" :key="timeStamp"/>
    <protect-setting v-if="defaultMenuCode==='092'" :key="timeStamp"/>
    <carbon-limit v-if="defaultMenuCode==='093'" :key="timeStamp"/>
    <demand-setting v-if="defaultMenuCode==='094'" :key="timeStamp"/>
    <product-value v-if="defaultMenuCode==='095'" :key="timeStamp"/>
    <building-manage v-if="defaultMenuCode==='096'" :key="timeStamp"/>
    <device-manage v-if="defaultMenuCode==='097'" :key="timeStamp"/>
    <permission-manage v-if="defaultMenuCode==='098'" :key="timeStamp"/>
    <!-- 碳汇工具 -->
    <carbon-check v-if="defaultMenuCode==='101'" :key="timeStamp"/>
  </el-main>
</template>

<script>
import SiteScreen1 from "../../EnergyEfficiency/SiteScreen/SiteScreen1";
import SiteScreen2 from "../../EnergyEfficiency/SiteScreen/SiteScreen2";
import SiteScreen3 from "../../EnergyEfficiency/SiteScreen/SiteScreen3";
import Configuration from "../../EnergyEfficiency/EnergyMonitor/Configuration";
import EnergyRealtime from "../../EnergyEfficiency/EnergyMonitor/EnergyRealtime";
import EnergyParameter from "../../EnergyEfficiency/EnergyMonitor/EnergyParameter";
import TransferMonitor from "../../EnergyEfficiency/EnergyMonitor/TransferMonitor";
import EnergyStatistics from "../../EnergyEfficiency/EnergyAnalyse/EnergyStatistics";
import SegStatistics from "../../EnergyEfficiency/EnergyAnalyse/SegStatistics";
import LossAnalyse from "../../EnergyEfficiency/EnergyAnalyse/LossAnalyse";
import TransferAnalyse from "../../EnergyEfficiency/EnergyAnalyse/TransferAnalyse";
import EnergyContrast from "../../EnergyEfficiency/EnergyAnalyse/EnergyContrast";
import ProtectAnalyse from "../../EnergyEfficiency/EnergyAnalyse/ProtectAnalyse";
import DemandAnalyse from "../../EnergyEfficiency/EnergyAnalyse/DemandAnalyse";
import HarmonicAnalyse from "../../EnergyEfficiency/EnergyQuality/HarmonicAnalyse";
import UnbalanceAnalyse from "../../EnergyEfficiency/EnergyQuality/UnbalanceAnalyse";
import PowFactorAnalyse from "../../EnergyEfficiency/EnergyQuality/PowFactorAnalyse";
import EnergySafety from "../../EnergyEfficiency/EnergySafety/EnergySafety";
import WarningQuery from "../../EnergyEfficiency/WarningManage/WarningQuery";
import WarningProfile from "../../EnergyEfficiency/WarningManage/WarningProfile";
import DeviceDoc from "../../EnergyEfficiency/DeviceDoc/DeviceDoc";
import EnergyReport from "../../EnergyEfficiency/FormManage/EnergyReport";
import YuxingEnergyReport from "../../EnergyEfficiency/CustomizeManage/YuxingEnergyReport";
import ExpenseReport from "../../EnergyEfficiency/FormManage/ExpenseReport";
import DemandReport from "../../EnergyEfficiency/FormManage/DemandReport";
import ParameterReport from "../../EnergyEfficiency/FormManage/ParameterReport";
import SaveEnergyReport from "../../EnergyEfficiency/ReportManage/SaveEnergyReport";
import EnergyQualityReport from "../../EnergyEfficiency/ReportManage/EnergyQualityReport";
import EnergySafetyReport from "../../EnergyEfficiency/ReportManage/EnergySafetyReport";
import EnergyPrice from "../../EnergyEfficiency/SystemSetting/EnergyPrice";
import ProtectSetting from "../../EnergyEfficiency/SystemSetting/ProtectSetting";
import CarbonLimit from "../../EnergyEfficiency/SystemSetting/CarbonLimit";
import DemandSetting from "../../EnergyEfficiency/SystemSetting/DemandSetting";
import ProductValue from "../../EnergyEfficiency/SystemSetting/ProductValue";
import BuildingManage from "../../EnergyEfficiency/SystemSetting/BuildingManage";
import DeviceManage from "../../EnergyEfficiency/SystemSetting/DeviceManage";
import PermissionManage from "../../EnergyEfficiency/SystemSetting/PermissionManage";
import CarbonCheck from "../../EnergyEfficiency/CarbonManage/CarbonCheck";
import ProtectDevice from "../../EnergyEfficiency/ExtraDevice/ProtectDevice";

export default {
  name: "ModuleSelector",
  components: {
    SiteScreen1, SiteScreen2, SiteScreen3,
    Configuration, EnergyRealtime, EnergyParameter, TransferMonitor,
    EnergyStatistics, SegStatistics, LossAnalyse, TransferAnalyse, EnergyContrast, ProtectAnalyse, DemandAnalyse,
    HarmonicAnalyse, UnbalanceAnalyse, PowFactorAnalyse,
    EnergySafety,
    WarningQuery, WarningProfile,
    DeviceDoc,
    EnergyReport, YuxingEnergyReport, ExpenseReport, DemandReport, ParameterReport,
    SaveEnergyReport, EnergyQualityReport, EnergySafetyReport,
    EnergyPrice, ProtectSetting, CarbonLimit, DemandSetting, ProductValue, BuildingManage, DeviceManage, PermissionManage,
    CarbonCheck,
    ProtectDevice
  },
  props: {
    timeStamp: {
      type: Number,
      default() {
        return 0;
      }
    },
    defaultMenuCode: {
      type: String,
      default () {
        return '';
      }
    },
    systemId: {
      type: String,
      default () {
        return '';
      }
    },
    additionMap: {
      type: Map,
      default () {
        return null;
      }
    }
  },
  data() {
    return {
      lastId: ''
    }
  },
  created() {
    this.lastId = this.defaultMenuCode
  },
  watch: {
    defaultMenuCode: function (newV, oldV) {
      if (!newV.startsWith('00')) {
        this.lastId = newV
      }
    }
  },
  methods: {
    reloadPage() {
      this.$emit('menuClick', this.lastId)
    }
  }
}
</script>

<style scoped>
  .module-panel{
    margin: 0;
    padding: 0;
    height: 100%;
    background: #f8f8f8;
  }
  .energy-module-panel{
    margin: 0;
    padding: 24px 24px 0 24px;
    width: 100%;
    height: 100%;
  }
  .full-module-panel{
    padding: 0;
    width: 100%;
    height: calc(100% - 1px);
    margin-top: 1px;
  }
  .epidemic-module-panel{
    margin: 0;
    padding: 1px;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
  }
  .entrance-panel{
    width: 100%;
    height: 100%;
    background: #f8f8f8;
  }
  .entrance-panel-left{
    height: 100%;
  }
  .entrance-panel-right{
    height: 100%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/main/ModuleSelector.vue